import { useEffect, useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import "./style.scss";
import ParkingService from "../../../../services/ParkingService";
import FilterModal from "./FilterModal";
import { usePermissions } from "../../../common/permissions";

const Parking = () => {
	const [data, setData] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [modal, setModal] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const parkingService = new ParkingService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canAdd } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);
	const [params, setParams] = useState({});
	const [param, setParam] = useState({});
	const search = useSelector((state) => state.auth.search);

	useEffect(() => {
		let info = {};
		if (!!params?.client_name) info["client_name"] = params?.client_name;
		if (!!params?.client_phone) info["client_phone"] = params?.client_phone;
		if (!!params?.vehicle_number)
			info["vehicle_number"] = params?.vehicle_number;
		if (!!params?.zone) info["zone_id"] = params?.zone?.value;
		if (!!params?.parking_slot) info["slot_id"] = params?.parking_slot?.value;
		if (!!params?.floor) info["floor"] = params?.floor?.value;
		if (!!params?.status) info["status"] = params?.status?.value;
		if (!!params?.type) info["parking_type"] = params?.type?.value;

		setParam({ ...info });
		setShouldUpdate((prev) => !prev);
	}, [params]);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].parking}
						</span>
					</div>
					<div className="add-admin d-flex gap-8">
						<Button
							variant="outline-primary"
							onClick={() => setModal(true)}
							className="px-3">
							<i class="las la-filter"></i>
						</Button>
						{canAdd("parking") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									navigate("/parking/add-parking");
								}}>
								<i
									className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
								{Translate[lang]?.add} {lang === "en" ? "Parking" : "حجز جديد"}
							</Button>
						)}
					</div>
				</div>

				{Object.keys(params).length > 0 && (
					<div className="mt-4">
						{Object.entries(params).map(([key, value]) => (
							<span
								key={key}
								style={{
									marginRight: "16px",
									display: "inline-block",
									border: "1px solid var(--primary)",
									borderRadius: "10px",
									padding: "8px 16px",
									color: "#000",
									marginBottom: "12px",
								}}>
								{Translate[lang][key]}:
								<span className="text-primary mx-2">
									{value?.label || value}
								</span>
								<i
									className="las la-times text-danger cursor-pointer"
									onClick={() => {
										let paramsData = { ...params };
										delete paramsData[key];
										setParams(paramsData);
									}}
								/>
							</span>
						))}
						<button
							className="text-danger"
							onClick={() => setParams({})}
							style={{
								background: "none",
								border: "0",
							}}>
							{Translate[lang].clear_filter}
						</button>
					</div>
				)}
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.client_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.zone}</strong>
									</th>

									<th>
										<strong>{Translate[lang]?.floor}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.parking_slot}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.vehicle_number}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.vehicle_color}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.vehicle_images}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.entry_time}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.exit_time}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.total_parking_duration}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.assigned_driver}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.qr_code}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.status}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={parkingService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={{ ...param }}
					/>
				</div>
			</div>
			{modal && (
				<FilterModal
					modal={modal}
					setModal={() => setModal(false)}
					params={params}
					setParams={setParams}
				/>
			)}
		</div>
	);
};
export default Parking;
